import { createContext, useContext } from "react";

import type { ToastApi } from "./types-toast";

export const ToastContext = createContext<ToastApi | null>(null);

/** API do toast do `ToastProvider` mais próximo; lança fora dele. */
export function useToast(): ToastApi {
  const context = useContext(ToastContext);
  if (!context) throw new Error("useToast deve ser usado dentro de ToastProvider");
  return context;
}
